import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next';
import { Button, Card, CardBody } from 'reactstrap';
import { useRecoverPassword } from '../../hooks/useRecoverPassword';
import Message from '../../components/Message';
import HtmlParser from 'react-html-parser';
import LoadingSpinner from '../../components/LoadingSpinner';

const ChangePassword = props => {
    const [loginData, setLoginData] = useState({});
    const [responseData, setResponseData] = useState({});
    const [showForm, setShowForm] = useState(false)
    const [token, setToken] = useState('');
    const [t] = useTranslation('app');
    const { loading, validateToken, setNewPassword } = useRecoverPassword()
    const logo = process.env.REACT_APP_IMAGE_BAR;

    useEffect(() => {
        setToken(window.location.pathname.split('/password-change/').join(''))
        validateToken(window.location.pathname.split('/password-change/').join('')).then((res) => {
            setShowForm(true)
        }).catch((e) => {
            setShowForm(false)
            setResponseData({
                message: t('login.password_recovery.error1')
            })
        })
    }, [])

    const handleChange = ({ target: { value, name } }) => {
        setLoginData((prev) => {
            return {
                ...prev,
                [name]: value
            };
        });
    };

    const onSubmit = async (e) => {
        e.preventDefault();
        if (loginData['password'] !== loginData['repeatPassword'])
            return setResponseData({
                type: 'error',
                message: t('login.password_recovery.error2')
            })
        setNewPassword(token, loginData['password']).then((res) => {
            setResponseData({
                type: res.color === 'green' ? 'success' : 'error',
                message: res.message
            })
        })
    };

    return (
        <form onSubmit={onSubmit}>
            <div className="Login">
                <div className="container">
                    <div className="Login-wrapper">
                        <Card className="Login-card">
                            <CardBody className="Login-content">
                                <img className="Login-logo" src={logo} alt="logo" />
                                {showForm ? <>
                                    {responseData.type && <Message type={responseData.type}> {HtmlParser(responseData.message)} </Message>}
                                    <input
                                        className="Login-input"
                                        type="password"
                                        placeholder={t('login.password')}
                                        name="password"
                                        onChange={handleChange}
                                        required
                                    />
                                    <input
                                        className="Login-input"
                                        type="password"
                                        placeholder={t('login.password_recovery.repeat_password')}
                                        name="repeatPassword"
                                        onChange={handleChange}
                                        required
                                    />
                                    <Button className="Login-btn" type="submit">
                                        {loading ? <LoadingSpinner show /> : t('confirm')}
                                    </Button>
                                </> : <Message type='error'> {HtmlParser(responseData.message)} </Message>}
                            </CardBody>
                        </Card>
                    </div>
                </div>
            </div>
        </form>
    )
}

ChangePassword.propTypes = {}

export default ChangePassword